<template>
  <footer
    :class="[
      'helpcenter-footer',
      { 'helpcenter-footer--loading': isCustomerLoading }
    ]"
  >
    <button
      class="helpcenter-footer__button"
      data-testid="email-button"
      @click="handleEmailClick"
    >
      <strong class="text-p5-semibold">E-mail</strong>
      <span>meajuda@warren.com.br</span>
    </button>

    <button
      class="helpcenter-footer__button"
      data-testid="chat-button"
      :disabled="isChatLoading"
      @click="handleChatClick"
    >
      <strong class="text-p5-semibold">Chat</strong>
      <span>2ª à 6ª, das 8h às 18h</span>
    </button>
  </footer>
</template>

<script lang="ts">
import { namespace } from 'vuex-class';
import { Component, Vue } from 'vue-property-decorator';

import { ICustomer } from '@/types/models';
import { trackChatContact, trackEmailContact } from '../../help-center-tracker';
import { zendeskLoader } from '@/modules/common/services/zendesk/zendesk-loader';

const customerModule = namespace('CustomerModule');

@Component({ name: 'HelpCenterFooter' })
export default class HelpCenterFooter extends Vue {
  @customerModule.Getter('getCustomer')
  private customer?: ICustomer;

  private isChatLoading = false;

  get isCustomerLoading() {
    return !this.customer;
  }

  async handleChatClick() {
    if (this.isChatLoading) return;

    try {
      this.isChatLoading = true;
      await this.openZendeskChat();
      trackChatContact();
    } catch (error) {
      console.error('Erro ao abrir chat:', error);
    } finally {
      this.isChatLoading = false;
    }
  }

  handleEmailClick() {
    this.openEmailClient();
    trackEmailContact();
  }

  private async openZendeskChat() {
    await zendeskLoader.openChat();
  }

  openEmailClient() {
    window.location.href = 'mailto:meajuda@warren.com.br';
  }
}
</script>

<style lang="less" scoped>
.helpcenter-footer {
  background-color: @background-primary;
  border-top: 1px solid @divider-primary;
  width: 100%;
  height: @size-spacing-x1100;

  display: flex;
  justify-content: center;
  align-items: center;

  position: fixed;
  left: 0;
  bottom: 0;
  z-index: 20;

  &--loading &__button {
    opacity: 0;
    pointer-events: none;
  }

  &__button {
    color: @text-primary;
    text-align: center;
    margin-right: @size-spacing-x800;
    transition: opacity 200ms ease-in;
    cursor: pointer;

    > span {
      color: @text-secondary;
      font-size: 12px;
      display: block;
    }
  }

  @media @mobile {
    justify-content: space-around;

    &_button {
      margin: 0;
    }
  }
}
</style>
